import { defineStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/styled-system';

const Button = defineStyleConfig({
    baseStyle: {},
    sizes: {
        md: {
            header: {
                fontSize: '22px',
                fontWeight: '500',
                lineHeight: '30px',
                padding: '40px 40px 30px',
            },
            dialog: {
                maxW: '450px',
                border: '10px',
            },
            dialogContainer: {
                padding: '0 25px',
            },
        },
    },
    variants: {
        primary: (props: StyleFunctionProps) => ({
            overlay: {
                bg:
                    props.colorMode === 'light'
                        ? 'linear-gradient(0deg, rgba(6, 13, 47, 0.3), rgba(6, 13, 47, 0.3))'
                        : 'linear-gradient(0deg, rgba(6, 13, 47, 0.6), rgba(6, 13, 47, 0.6))',
            },
            dialog: {
                shadow: 'none',
                bg: props.colorMode === 'light' ? 'white' : 'midnightBlue',
            },
            header: {
                textAlign: 'center',
            },
            body: {
                padding: '0 40px 30px',
            },
            footer: {
                justifyContent: 'center',
                padding: '0 40px 40px',
            },
        }),
    },
    defaultProps: {
        variant: 'primary',
        size: 'md',
    },
});
export default Button;
